const state = {
    submissions: [],
    submission: {
        submission: {
            status: "",
        },
        address: [],
        personal_details: {
            telephone_international_dialling_code: {},
            mobile_international_dialling_code: {},
        },
        employment_details: {},
        investment_experience: {},
        investment_objectives: {},
        financial_circumstances: {},
        legal_documentation: {},
        declaration: {},
    },
    documents: {
        gbg_report: {},
    },
};

const getters = {
    submissions: (state) => state.submissions,
    submission: (state) => state.submission,
    documents: (state) => state.documents,
};

const actions = {
    async doGetSubmissions({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions").then(
                (response) => {
                    commit("setSubmissions", response.data);
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doGetSubmission({ commit }, userId) {
        commit("resetSubmissionData");
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/" + userId).then(
                (response) => {
                    commit("setSubmission", response.data);
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doGetSubmissionBankingDetails({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/" + userId + "/details/banking").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doGenerateW8BENAdminUrl({ commit, rootState }, userId) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/" + userId + "/legal-documentation/w8ben").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doUpdateSubmissionStatus({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/submissions/" + rootState.submissions.submission.id + "/status", payload).then(
                (response) => {
                    commit("setSubmission", response.data);
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doSubmissionSearch({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
            this.throttle = setTimeout(() => {
                axios.post("/admin/submissions/search", payload).then(
                    (response) => {
                        commit("setSubmission", response.data);
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }, 500);
        });
    },
    async doBulkDeleteSubmissions({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/submissions/bulk-delete", payload).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doGenerateCsvExportUrl({ commit, rootState }, userId) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/" + userId + "/application-csv").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doGenerateAllSubmissionsCsvExportUrl({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/submitted-applications-csv").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doGenerateAllInProgressSubmissionsCsvExportUrl({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/in-progress-applications-csv").then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doUpdateSubmissionUserDetails({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
            this.throttle = setTimeout(() => {
                axios.patch("/admin/submissions/" + rootState.submissions.submission.id + "/details", payload).then(
                    (response) => {
                        commit("setSubmission", response.data);
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }, 500);
        });
    },
    async doGetSubmissionGbgReportDocument({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.get("/admin/submissions/" + userId + "/gbg").then(
                (response) => {
                    commit("setSubmissionGbgReport", response.data);
                    resolve(response.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    async doSaveSubmissionNotes({ commit, rootState }, payload) {
        return new Promise((resolve, reject) => {
            if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
            this.throttle = setTimeout(() => {
                axios.post("/admin/submissions/" + rootState.submissions.submission.id + "/notes", payload).then(
                    (response) => {
                        commit("setSubmission", response.data);
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            }, 1000);
        });
    },
};
const mutations = {
    setSubmissions: (state, submissionData) => {
        state.submissions = submissionData;
    },
    setSubmission: (state, submissionData) => {
        // Catering for if submissions are partially complete and Laravel relationships are returning null. This just replaces the null with an empty array so the front end can render without erroring
        Object.keys(submissionData).map((item) => {
            if (submissionData[item] === null) {
                return (submissionData[item] = []);
            }
            return submissionData[item];
        });
        state.submission = submissionData;
    },
    resetSubmissionData: (state) => {
        state.submission = {
            address: [],
            personal_details: {
                telephone_international_dialling_code: {},
                mobile_international_dialling_code: {},
            },
            employment_details: {},
            investment_experience: {},
            investment_objectives: {},
            financial_circumstances: {},
            legal_documentation: {},
            declaration: {},
        };
    },
    setSubmissionGbgReport: (state, documentData) => {
        state.documents.gbg_report = documentData;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
